module.exports = __webpack_public_path__ + "static/media/radial-tri-lateral-4.7db1e0b6.png";